import { ConsentId } from '@/shared/enums';
import EventType from './event-type';

export default {
  [EventType.AD_CLICKED]: [ConsentId.PERFORMANCE],
  [EventType.AD_FINISHED]: [ConsentId.PERFORMANCE],
  [EventType.AD_STARTED]: [ConsentId.PERFORMANCE],
  [EventType.START_PLAYING]: [ConsentId.PERFORMANCE],
  [EventType.PAUSE_PLAYING]: [ConsentId.PERFORMANCE],
  [EventType.STOP_PLAYING]: [ConsentId.PERFORMANCE],
  [EventType.BUFFERING_WHILE_PLAYING]: [ConsentId.PERFORMANCE],
  [EventType.ERROR_WHILE_PLAYING]: [ConsentId.PERFORMANCE],
  [EventType.CHANGE_PLAYING_SETTINGS]: [ConsentId.PERFORMANCE],
};
